export default __webpack_public_path__ + "static/media/templeoferlik.5837836e.jpg";